<template>
    <div v-if="carregado">

        <div style="margin-bottom: 10px;font-size: 14px;display: flex;gap: 5px;flex-wrap: wrap;">
            <span class="label label-sm"
                style="background-color: #1BBC9B !important; padding: 4px 6px; border-radius: 4px;">
                <i class="fa fa-wrench"></i> Tarefa
                <button class="botaoAdicionar" @click.prevent="InserirRegistro(8)">
                    +
                </button>
            </span>

            <span class="label label-sm"
                style="background-color: #87CEFA !important; padding: 4px 6px; border-radius: 4px; border: 1px solid white;">
                <i class="fa fa-cube"></i> Comprado
                <button class="botaoAdicionar" @click.prevent="InserirRegistro(4)">
                    +
                </button>
            </span>

            <span class="label label-sm"
                style="background-color: #FFA500 !important; padding: 4px 6px; border-radius: 4px;">
                <i class="fa fa-cubes"></i> Manufaturado
                <button class="botaoAdicionar" @click.prevent="InserirRegistro(1)">
                    +
                </button>
            </span>
            <span class="label label-sm"
                style="background-color: #DAA520 !important; padding: 4px 6px; border-radius: 4px;">
                <i class="fa fa-industry"></i> Industria
                <button class="botaoAdicionar" @click.prevent="InserirRegistro(9)">
                    +
                </button>
            </span>
            <span class="label label-sm"
                style="background-color: #4682B4 !important; padding: 4px 6px; border-radius: 4px;">
                <i class="fa fa-cogs"></i> Serviço
                <button class="botaoAdicionar" @click.prevent="InserirRegistro(3)">
                    +
                </button>
            </span>
        </div>

        <DxTreeList
            ref="gridTreeList"
            id="gridTreeList"
            :data-source="Dados"
            :column-auto-width="true"
            :word-wrap-enabled="true"
            :show-row-lines="true"
            :show-borders="true"
            :expanded-row-keys="expandedRowKeys"
            key-expr="Key"
            parent-id-expr="ProdutoPai"
            @selection-changed="onRowSelected"                       
        >

            <DxSearchPanel         
                :visible="true"
                :width="280"
                placeholder="Pesquisar..."
            />

            <DxSelection mode="single" />
            <DxSorting mode="multiple" />
            <DxColumn :min-width="400" data-field="Nome" caption="Nome" />
            <DxColumn :min-width="50" data-field="Icon" caption="Tipo" cell-template="iconCell" />
            <DxColumn :min-width="80" data-field="Posicao" caption="Posição" />
            <DxColumn :min-width="80" data-field="Serie" caption="Série" />

            <template #iconCell="{ data }">
                <div v-html="data.data.Icon"></div>
            </template>
        </DxTreeList>

    </div>
</template>

<script>
import {
    DxTreeList, DxSorting, DxColumn, DxSelection, DxSearchPanel
} from 'devextreme-vue/tree-list';

const expandedRowKeys = [0];

export default {
    components: {
        DxTreeList,
        DxSorting,
        DxColumn,
        DxSelection,
        DxSearchPanel
    },
    data() {
        return {
            Dados: [],
            expandedRowKeys,
            linhaSelecionada: null,            
        };
    },
    computed: {
        carregado() {
            return this.$store.state.data.carregado;
        },
        numberloaded() {
            return this.$store.state.data.numberLoaded;
        },
        numberLoadedLinhaSelecionada() {
            return this.$store.state.data.numberLoadedLinhaSelecionada;
        }
    },
    watch: {
        numberloaded: function (value) {            
            this.LoadData();
        },
        numberLoadedLinhaSelecionada: function (value) {
            let linha = this.$store.state.data.linhaSelecionadaFixa;            
            this.$nextTick(() => {                        
                const treeList = this.$refs.gridTreeList.instance; 
                treeList.selectRows([linha], false); 
            });
        }
    },
    methods: {
        LoadData: function () {
            let produto = this.$store.state.filtro.produto;
            let variacao = this.$store.state.filtro.variacao;
            let exibeInativo = this.$store.state.filtro.exibeInativo;

            let urlApi = Benner.Page.getApplicationPath() + "api/Producao/EstruturaProdutos/Estrutura?produto=" + produto + "&variacao=" + variacao + "&exibeInativo=" + exibeInativo;
            $.ajax({
                type: "GET",
                url: urlApi,
                success: (data) => {  
                    let idProdutoAnterior = this.Dados.length > 0 ? this.Dados[0].Key : null;                                         
                    let idProdutoAtual = data.length > 0 ? data[0].Key : null;                    
                    
                    this.Dados = data;                    
                    let selecionado = idProdutoAtual;                                    

                    if (idProdutoAnterior !== idProdutoAtual) {
                        this.linhaSelecionada = null;
                        expandedRowKeys.length = 0;   
                    }
                        
                    if (this.linhaSelecionada) {
                        let selecionadoExisteNoData = this.Dados.some(item => item.Key === this.linhaSelecionada.Key);

                        if (selecionadoExisteNoData) {
                            expandedRowKeys.push(this.linhaSelecionada.Key, this.linhaSelecionada.ProdutoPai);                        
                            selecionado = this.linhaSelecionada.Key;
                        }          
                        else {
                            expandedRowKeys.push(this.linhaSelecionada.ProdutoPai);                        
                            selecionado = this.linhaSelecionada.ProdutoPai;
                        }
                    }
                    
                    expandedRowKeys.push(idProdutoAtual);                    

                    this.$nextTick(() => {                        
                        const treeList = this.$refs.gridTreeList.instance; 
                        treeList.selectRows([selecionado], false); 
                    });

                    Benner.ModalMessage.hide();
                },
                error: function (error) {
                    console.log(error);
                }
            }).done(function (data) {
                Benner.AsyncProcesses.initAjax();
            }).fail(function (xhr, status, error) {
                console.error('Erro na requisição:', error);
            });
        },
        onRowSelected(e) {            
            this.linhaSelecionada = e.component.getSelectedRowsData()[0];            
            if (this.linhaSelecionada) {
                HabilitarFormularioEdicao(this.linhaSelecionada);
            }
        },
        InserirRegistro(tipo) {
            Inserir(tipo);
        }
    },
};
</script>

<style>
#gridTreeList {
    max-height: 800px;
}
</style>